import { Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CrossButton from "assets/Primary_white.svg";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { submitSuggestedPlansFeedbackAsync } from "./Suggested.slice";
interface Prop {
  cmsId: number;
  planName: string;
}

function InvalidPlanButton(props: Prop) {
  const { cmsId, planName } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const submitFeedback = async (input: any) => {
    setOpen(false);
    const props = {
      feedbacks: [
        {
          cmsId: cmsId,
          helpfulYN: "N",
          inncode: innCode
        }
      ]
    };
    await dispatch(submitSuggestedPlansFeedbackAsync(props));
    dispatch(
      setFeedbackDetails({
        shouldShow: true,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: "Plan removed from suggestions",
        variant: "success"
      })
    );
  };

  return (
    <>
      <Tooltip title="Suggestion is not useful">
        <Button
          accessType={accessTypes.delete}
          iconButton
          icon={CrossButton}
          height="34"
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <DialogFormation
        openDialog={open}
        handleClose={() => setOpen(false)}
        title="Plan Removal"
        actionConfig={
          <div className="modal-config-wrapper">
            <Button label="Cancel" variant="secondary" onClick={() => setOpen(false)} />
            <Button
              accessType={accessTypes.delete}
              variant="alert"
              label="Delete"
              onClick={submitFeedback}
              sx={{
                backgroundColor: tokens.Icon.Feeback.Alert,
                color: tokens.Text.General.Inverse,
                "&:hover": { color: tokens.Icon.Feeback.Alert }
              }}
            />
          </div>
        }
      >
        <Typography
          variant="body1"
          color={tokens.Text.General.PrimaryHeadline}
          sx={{ textAlign: "center", marginTop: "10px" }}
        >
          You’re about to remove the plan
          <Box component="span" sx={{ color: tokens.Text.General.PrimaryHeadline, fontWeight: 600 }}>
            {" "}
            {planName}
          </Box>{" "}
          from the suggested plans area. Please confirm your decision before proceeding.
        </Typography>
      </DialogFormation>
    </>
  );
}

export default InvalidPlanButton;
